// 事务单-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :type="editViewType" :workTypeDisable="workTypeDisable" :workTypeName="workTypeName" :processId="processId" :_dataId.sync="dataId"
                  :parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex" @editViewDataUpdate="editViewDataUpdate"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div style=" height: calc(100vh - -72px);">
          <vxe-grid show-overflow :stripe="true" border="default" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption" height="100%"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl" v-if="workTypeName == null">
                  <vxe-button v-if="addButton" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(0, 'edit')">新增
                  </vxe-button>
                  <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog(null, 'edit')">批量导入
                  </vxe-button> -->
                  <vxe-button v-if="exportButton" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fl" v-if="workTypeName == '配件无果二次回访申请'">
                  <vxe-button v-if="addButtonPjwg" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(0, 'edit')">新增
                  </vxe-button>
                  <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog(null, 'edit')">批量导入
                  </vxe-button> -->
                  <vxe-button v-if="exportButtonPjwg" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fl" v-if="workTypeName == '服务工单二次回访申请'">
                  <vxe-button v-if="addButtonFwgd" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(0, 'edit')">新增
                  </vxe-button>
                  <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog(null, 'edit')">批量导入
                  </vxe-button> -->
                  <vxe-button v-if="exportButtonFwgd" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fl" v-if="workTypeName == '申请工单驳回'">
                  <vxe-button v-if="addButtonSqgd" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(0, 'edit')">新增
                  </vxe-button>
                  <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog(null, 'edit')">批量导入
                  </vxe-button> -->
                  <vxe-button v-if="exportButtonSqgd" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fl" v-if="workTypeName == '免考核申请'">
                  <vxe-button v-if="addButtonMkhsq" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(0, 'edit')">新增
                  </vxe-button>
                  <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog(null, 'edit')">批量导入
                  </vxe-button> -->
                  <vxe-button v-if="exportButtonMkhsq" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fl" v-if="workTypeName == '突发性特殊情况报备'">
                  <vxe-button v-if="addButtonTfx" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(0, 'edit')">新增
                  </vxe-button>
                  <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog(null, 'edit')">批量导入
                  </vxe-button> -->
                  <vxe-button v-if="exportButtonTfx" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" class="screen-box" title-width="5vw" title-align="right" :data="formData"
                          @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="事务单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.billNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="事务类型:" field="workType" >
                    <template v-slot>
                      <el-select v-model="formData.workType" style="width: 8vw;" clearable :disabled="workTypeDisable">
                        <el-option v-for="item in workTypes" :key="item.id" :label="item.label"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <el-autocomplete class="inline-input" style="width:9vw ;" v-model="formData.siteName"
                                       :fetch-suggestions="querySiteSearch" placeholder="" :trigger-on-focus="false"
                                       @select="handleSiteSelect" clearable />
                    </template>
                  </vxe-form-item>



                  <vxe-form-item title="创建时间:" field="name" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 18vw;" v-model="formData.createDate" type="daterange" align="right"
                                      unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
                    btnGoodsStatusBt1: goodsStatusIndex == index,
                    btnGoodsStatusBt: goodsStatusIndex != index
                  }" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color" v-if="item.name !== '所有'">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>
            <template #option="{row}">
              <div v-if="workTypeName == null">
                <a href="javascript:void(0);" v-if="editButton" class="a-link" @click="openEditDialog(row, 'edit')">
                  <el-tooltip :enterable=false effect="dark" content="编辑" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)" v-if="row.stat==1||row.stat==2||row.stat==5 || row.stat==6">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="1" v-if="row.stat==1 && row.processId==null">启动流程</el-dropdown-item>
                    <!-- <el-dropdown-item command="2" >审核</el-dropdown-item> -->
                    <el-dropdown-item command="2" v-if="row.processId==null && row.stat ==2&&checkButton">审核</el-dropdown-item>
                    <el-dropdown-item command="3" v-if="row.processId==null && row.stat ==2&&rejectButton">驳回</el-dropdown-item>
                    <el-dropdown-item command="4" v-if="row.processId==null && (row.stat ==1||row.stat == 6)&&cancelButton">取消</el-dropdown-item>
                    <!--                    <el-dropdown-item command="5" v-if="row.processId==null && row.stat ==6&&submitButton">重新提交</el-dropdown-item>-->
                    <el-dropdown-item command="6" v-if="row.processId==null && row.stat ==1&&submitButton">提交</el-dropdown-item>
                    <el-dropdown-item command="7" v-if="row.processId!=null">查看流程</el-dropdown-item>
                  </el-dropdown-menu>


                </el-dropdown>

              </div>
              <div v-if="workTypeName == '配件无果二次回访申请'">
                <a href="javascript:void(0);" v-if="editButtonPjwg" class="a-link" @click="openEditDialog(row, 'edit')">
                  <el-tooltip :enterable=false effect="dark" content="编辑" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)" v-if="row.stat==1||row.stat==2||row.stat==5 || row.stat==6">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="1" v-if="row.stat==1 && row.processId==null && startWfButtonPjwg">启动流程</el-dropdown-item>
                    <!-- <el-dropdown-item command="2" >审核</el-dropdown-item> -->
                    <el-dropdown-item command="2" v-if="row.processId==null && row.stat ==2&&checkButtonPjwg">审核</el-dropdown-item>
                    <el-dropdown-item command="3" v-if="row.processId==null && row.stat ==2&&rejectButtonPjwg">驳回</el-dropdown-item>
                    <el-dropdown-item command="4" v-if="row.processId==null && (row.stat ==1||row.stat == 6)&&cancelButtonPjwg">取消</el-dropdown-item>
                    <!--                    <el-dropdown-item command="5" v-if="row.processId==null && row.stat ==6&&submitButton">重新提交</el-dropdown-item>-->
                    <el-dropdown-item command="6" v-if="row.processId==null && row.stat ==1&&submitButtonPjwg">提交</el-dropdown-item>
                    <el-dropdown-item command="7" v-if="row.processId!=null">查看流程</el-dropdown-item>
                  </el-dropdown-menu>


                </el-dropdown>

              </div>
              <div v-if="workTypeName == '服务工单二次回访申请'">
                <a href="javascript:void(0);" v-if="editButtonFwgd" class="a-link" @click="openEditDialog(row, 'edit')">
                  <el-tooltip :enterable=false effect="dark" content="编辑" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)" v-if="row.stat==1||row.stat==2||row.stat==5 || row.stat==6">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="1" v-if="row.stat==1 && row.processId==null && startWfButtonFwgd">启动流程</el-dropdown-item>
                    <!-- <el-dropdown-item command="2" >审核</el-dropdown-item> -->
                    <el-dropdown-item command="2" v-if="row.processId==null && row.stat ==2&&checkButtonFwgd">审核</el-dropdown-item>
                    <el-dropdown-item command="3" v-if="row.processId==null && row.stat ==2&&rejectButtonFwgd">驳回</el-dropdown-item>
                    <el-dropdown-item command="4" v-if="row.processId==null && (row.stat ==1||row.stat == 6)&&cancelButtonFwgd">取消</el-dropdown-item>
                    <!--                    <el-dropdown-item command="5" v-if="row.processId==null && row.stat ==6&&submitButton">重新提交</el-dropdown-item>-->
                    <el-dropdown-item command="6" v-if="row.processId==null && row.stat ==1&&submitButtonFwgd">提交</el-dropdown-item>
                    <el-dropdown-item command="7" v-if="row.processId!=null">查看流程</el-dropdown-item>
                  </el-dropdown-menu>


                </el-dropdown>

              </div>
              <div v-if="workTypeName == '申请工单驳回'">
                <a href="javascript:void(0);" v-if="editButtonSqgd" class="a-link" @click="openEditDialog(row, 'edit')">
                  <el-tooltip :enterable=false effect="dark" content="编辑" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)" v-if="row.stat==1||row.stat==2||row.stat==5 || row.stat==6">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="1" v-if="row.stat==1 && row.processId==null && startWfButtonSqgd">启动流程</el-dropdown-item>
                    <!-- <el-dropdown-item command="2" >审核</el-dropdown-item> -->
                    <el-dropdown-item command="2" v-if="row.processId==null && row.stat ==2&&checkButtonSqgd">审核</el-dropdown-item>
                    <el-dropdown-item command="3" v-if="row.processId==null && row.stat ==2&&rejectButtonSqgd">驳回</el-dropdown-item>
                    <el-dropdown-item command="4" v-if="row.processId==null && (row.stat ==1||row.stat == 6)&&cancelButtonSqgd">取消</el-dropdown-item>
                    <!--                    <el-dropdown-item command="5" v-if="row.processId==null && row.stat ==6&&submitButton">重新提交</el-dropdown-item>-->
                    <el-dropdown-item command="6" v-if="row.processId==null && row.stat ==1&&submitButtonSqgd">提交</el-dropdown-item>
                    <el-dropdown-item command="7" v-if="row.processId!=null">查看流程</el-dropdown-item>
                  </el-dropdown-menu>


                </el-dropdown>

              </div>
              <div v-if="workTypeName == '免考核申请'">
                <a href="javascript:void(0);" v-if="editButtonMkhsq" class="a-link" @click="openEditDialog(row, 'edit')">
                  <el-tooltip :enterable=false effect="dark" content="编辑" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)" v-if="row.stat==1||row.stat==2||row.stat==5 || row.stat==6">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="1" v-if="row.stat==1 && row.processId==null && startWfButtonMkhsq">启动流程</el-dropdown-item>
                    <!-- <el-dropdown-item command="2" >审核</el-dropdown-item> -->
                    <el-dropdown-item command="2" v-if="row.processId==null && row.stat ==2&&checkButtonMkhsq">审核</el-dropdown-item>
                    <el-dropdown-item command="3" v-if="row.processId==null && row.stat ==2&&rejectButtonMkhsq">驳回</el-dropdown-item>
                    <el-dropdown-item command="4" v-if="row.processId==null && (row.stat ==1||row.stat == 6)&&cancelButtonMkhsq">取消</el-dropdown-item>
                    <!--                    <el-dropdown-item command="5" v-if="row.processId==null && row.stat ==6&&submitButton">重新提交</el-dropdown-item>-->
                    <el-dropdown-item command="6" v-if="row.processId==null && row.stat ==1&&submitButtonMkhsq">提交</el-dropdown-item>
                    <el-dropdown-item command="7" v-if="row.processId!=null">查看流程</el-dropdown-item>
                  </el-dropdown-menu>


                </el-dropdown>

              </div>
              <div v-if="workTypeName == '突发性特殊情况报备'">
                <a href="javascript:void(0);" v-if="editButtonTfx" class="a-link" @click="openEditDialog(row, 'edit')">
                  <el-tooltip :enterable=false effect="dark" content="编辑" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)" v-if="row.stat==1||row.stat==2||row.stat==5 || row.stat==6">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="1" v-if="row.stat==1 && row.processId==null && startWfButtonTfx">启动流程</el-dropdown-item>
                    <!-- <el-dropdown-item command="2" >审核</el-dropdown-item> -->
                    <el-dropdown-item command="2" v-if="row.processId==null && row.stat ==2&&checkButtonTfx">审核</el-dropdown-item>
                    <el-dropdown-item command="3" v-if="row.processId==null && row.stat ==2&&rejectButtonTfx">驳回</el-dropdown-item>
                    <el-dropdown-item command="4" v-if="row.processId==null && (row.stat ==1||row.stat == 6)&&cancelButtonTfx">取消</el-dropdown-item>
                    <!--                    <el-dropdown-item command="5" v-if="row.processId==null && row.stat ==6&&submitButton">重新提交</el-dropdown-item>-->
                    <el-dropdown-item command="6" v-if="row.processId==null && row.stat ==1&&submitButtonTfx">提交</el-dropdown-item>
                    <el-dropdown-item command="7" v-if="row.processId!=null">查看流程</el-dropdown-item>
                  </el-dropdown-menu>

                </el-dropdown>

              </div>

            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>


          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 查看流程弹框-->
    <el-dialog
      :visible.sync="showPicDialog"
      title="流程图">
      <img v-if="showPicDialog" :src="actPicUrl" width="100%">
    </el-dialog>
    <orderRemark v-if="showOrderRemaekDialog" @followUpOrderRemark="followUpOrderRemark" :visiable.sync="showOrderRemaekDialog"
                 :dataId="dataId"/>
  </div>
</template>

<script>
import editView from './edit.vue';
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import {dictType, loadDictData} from "@/config/dictType";
import orderRemark from "./orderRemarkDialog";
import request from "@/router/axios";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import pager from '@/components/pager/index.vue'
import { initVxeTable } from '@/const/crud/admin/table';

export default {
  name: 'business',

  inject: ['reload'],
  props: {
    workTypeName: String
  },
  components: { editView, pager,
    // 审核
    orderRemark,
  },
  data() {
    return {
      addButton :false,
      editButton :false,
      exportButton :false,
      submitButton :false,
      checkButton :false,
      rejectButton :false,
      cancelButton :false,
      //配件无果
      startWfButtonPjwg :false,
      addButtonPjwg :false,
      editButtonPjwg :false,
      exportButtonPjwg :false,
      submitButtonPjwg :false,
      checkButtonPjwg :false,
      rejectButtonPjwg :false,
      cancelButtonPjwg :false,
      //服务工单
      startWfButtonFwgd :false,
      addButtonFwgd :false,
      editButtonFwgd :false,
      exportButtonFwgd :false,
      submitButtonFwgd :false,
      checkButtonFwgd :false,
      rejectButtonFwgd :false,
      cancelButtonFwgd :false,
      //申请工单驳回
      startWfButtonSqgd :false,
      addButtonSqgd :false,
      editButtonSqgd :false,
      exportButtonSqgd :false,
      submitButtonSqgd :false,
      checkButtonSqgd :false,
      rejectButtonSqgd :false,
      cancelButtonSqgd :false,
      //免考核申请
      startWfButtonMkhsq :false,
      addButtonMkhsq :false,
      editButtonMkhsq :false,
      exportButtonMkhsq :false,
      submitButtonMkhsq :false,
      checkButtonMkhsq :false,
      rejectButtonMkhsq:false,
      cancelButtonMkhsq :false,
      //突发性特殊情况
      startWfButtonTfx :false,
      addButtonTfx :false,
      editButtonTfx :false,
      exportButtonTfx :false,
      submitButtonTfx :false,
      checkButtonTfx :false,
      rejectButtonTfx :false,
      cancelButtonTfx :false,


      showOrderRemaekDialog:false,
      processDefinitions: [],
      total: 0,
      editViewType: null,
      workTypes:[],
      actPicUrl:"",
      showPicDialog:false,
      workTypeName: "",
      workTypeDisable: false,
      requestParam: {
        // workType:1,
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        stat: 1,
        orgId: null,
        siteId: null,
        applyType: null,
        createTimeBegin: null,
        createTimeEnd: null,
        billNo: "",
      },

      formData: {
        // workType:2,

        stat: 1,
        orgId: null,
        siteId: null,
        applyType: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,

      },

      sitePromptList: [],

      goodsStatusList: [ //循环列表
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        { type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left' },
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        {
          title: '事务单号', field: 'billNo', width: 180, slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.showInfo(row, $event)}>{row.billNo}</span>
              ]
            }
          }
        },
        { title: '状态', field: 'stat', width: 125, slots: {
            default: ({ row }) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status ">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status neutral">
                    <span>审核中</span>
                  </div>
                ];
              }else if (row.stat == 5) {
                return [
                  <div class="txt-status ">
                    <span>已审核</span>
                  </div>
                ];
              }else if (row.stat == 6) {
                return [
                  <div class="txt-status disable">
                    <span>驳回</span>
                  </div>
                ];
              }else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          } },

        { title: '事务类型', field: 'workTypeName', width: 100, },
        { title: '部门名称', field: 'orgName', width: 100, },

        { title: '服务商', field: 'siteName', width: 100, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '创建人', field: 'createBy', width: 80, },


      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    console.log("this.workTypeName-----------------",this.workTypeName)
    this.addButton = this.permissions["wkWorkBillAdd"];
    this.editButton = this.permissions["wkWorkBillEdit"];
    this.exportButton = this.permissions["wkWorkBillExport"];
    this.submitButton= this.permissions["wkWorkBillSubmit"]; //提交
    this.checkButton= this.permissions["wkWorkBillCheck"]; //审核
    this.rejectButton= this.permissions["wkWorkBillReject"]; //驳回
    this.cancelButton= this.permissions["wkWorkBillCancel"]; //取消
    //配件无果
    this.startWfButtonPjwg = this.permissions["wkWorkBillStartWfPjwg"];
    this.addButtonPjwg = this.permissions["wkWorkBillAddPjwg"];
    this.editButtonPjwg = this.permissions["wkWorkBillEditPjwg"];
    this.exportButtonPjwg = this.permissions["wkWorkBillExportPjwg"];
    this.submitButtonPjwg= this.permissions["wkWorkBillSubmitPjwg"]; //提交
    this.checkButtonPjwg= this.permissions["wkWorkBillCheckPjwg"]; //审核
    this.rejectButtonPjwg= this.permissions["wkWorkBillRejectPjwg"]; //驳回
    this.cancelButtonPjwg= this.permissions["wkWorkBillCancelPjwg"]; //取消
    //服务工单
    this.startWfButtonFwgd = this.permissions["wkWorkBillStartWfFwgd"];
    this.addButtonFwgd = this.permissions["wkWorkBillAddFwgd"];
    this.editButtonFwgd = this.permissions["wkWorkBillEditFwgd"];
    this.exportButtonFwgd = this.permissions["wkWorkBillExportFwgd"];
    this.submitButtonFwgd = this.permissions["wkWorkBillSubmitFwgd"]; //提交
    this.checkButtonFwgd = this.permissions["wkWorkBillCheckFwgd"]; //审核
    this.rejectButtonFwgd = this.permissions["wkWorkBillRejectFwgd"]; //驳回
    this.cancelButtonFwgd = this.permissions["wkWorkBillCancelFwgd"]; //取消
    //申请工单驳回
    this.startWfButtonSqgd = this.permissions["wkWorkBillStartWfSqgd"];
    this.addButtonSqgd = this.permissions["wkWorkBillAddSqgd"];
    this.editButtonSqgd = this.permissions["wkWorkBillEditSqgd"];
    this.exportButtonSqgd = this.permissions["wkWorkBillExportSqgd"];
    this.submitButtonSqgd = this.permissions["wkWorkBillSubmitSqgd"]; //提交
    this.checkButtonSqgd = this.permissions["wkWorkBillCheckSqgd"]; //审核
    this.rejectButtonSqgd = this.permissions["wkWorkBillRejectSqgd"]; //驳回
    this.cancelButtonSqgd = this.permissions["wkWorkBillCancelSqgd"]; //取消
    //免考核申请
    this.startWfButtonMkhsq = this.permissions["wkWorkBillStartWfMkhsq"];
    this.addButtonMkhsq = this.permissions["wkWorkBillAddMkhsq"];
    this.editButtonMkhsq = this.permissions["wkWorkBillEditMkhsq"];
    this.exportButtonMkhsq = this.permissions["wkWorkBillExportMkhsq"];
    this.submitButtonMkhsq = this.permissions["wkWorkBillSubmitMkhsq"]; //提交
    this.checkButtonMkhsq = this.permissions["wkWorkBillCheckMkhsq"]; //审核
    this.rejectButtonMkhsq = this.permissions["wkWorkBillRejectMkhsq"]; //驳回
    this.cancelButtonMkhsq = this.permissions["wkWorkBillCancelMkhsq"]; //取消
    //突发性特殊情况
    this.startWfButtonTfx = this.permissions["wkWorkBillStartWfTfx"];
    this.addButtonTfx = this.permissions["wkWorkBillAddTfx"];
    this.editButtonTfx = this.permissions["wkWorkBillEditTfx"];
    this.exportButtonTfx = this.permissions["wkWorkBillExportTfx"];
    this.submitButtonTfx = this.permissions["wkWorkBillSubmitTfx"]; //提交
    this.checkButtonTfx = this.permissions["wkWorkBillCheckTfx"]; //审核
    this.rejectButtonTfx = this.permissions["wkWorkBillRejectTfx"]; //驳回
    this.cancelButtonTfx = this.permissions["wkWorkBillCancelTfx"]; //取消

    this.getWorkTypes()

  },

  mounted() {
    if (this.workTypeName) {
      this.workTypeDisable = true;
      // this.formData.workType = "0";
    }

    this.initSearchDate()
    this.loadTabOption()
    this.getProcessDefinitions()


  },

  methods: {
    toFilterData() {
      this.searchEvent();
    },
    //获取多流程
    getProcessDefinitions(){
      request({
        url: api.act.getProcessDefinitionsUrl,
        method: 'post',
        // data:this.formData,
        data: {tableKey: "WkWorkBill",},
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.processDefinitions = response.data.data
      })
    },

    editViewDataUpdate(){
      console.log("列表刷新");
      this.activeName='second'
      this.flushed()

    },
    // tab也切换为列表页
    goBackIndex() {
      console.log('到了列表页');
      this.activeName = 'second'
      this.showEdit = false
      this.flushed()
    },

    flushed() {
      this.loadTabOption()
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
      start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },
    getWorkTypes(){
      // this.$http({
      //   url: '/admin/dict/getItemListByDictType',
      //   method: 'post',
      //   data: {
      //     dictType: 'work_type'
      //   },
      //   isLoading: true,
      //   modalStrictly: true,
      // }).then(response => {
      //   this.workTypes = response.data.data;
      // })
      loadDictData(dictType.workType).then(res => {
        this.workTypes = res.data.data
        console.log("this.workTypes", this.workTypes)
        if (this.workTypes && this.workTypes.length > 0) {
          this.workTypes.forEach(item => {
            console.log("item", item)
            if (this.workTypeName == item.label) {
              this.formData.workType = item.id
              this.requestParam.workType = item.id

              console.log(this.formData.workType,"this.formData.workType的值7");
            }
          })
        }
      })
    },
    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: { userName: queryStr }
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({ value: item.userName, id: item.id })
        })
        callback(temp)
      })
    },


    // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.workBill.getCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        this.goodsStatusList = res.data.data
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      this.requestParam.stat = item.stat
      this.formData.stat = this.requestParam.stat
      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.workType = this.formData.workType

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 加载table数据
    getTableData() {
      this.getWorkTypes()
      console.log("api.workBill.getPageDataUrl------",this.requestParam)
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.workBill.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
      this.searchEvent()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      console.log(this.formData,"搜索");
      // this.requestParam.fuzzySearchIsEnable = !this.showMoreOptions
      let formData = this.formData
      this.requestParam.billNo = formData.billNo
      this.requestParam.stat = formData.stat
      this.requestParam.siteId = formData.siteId
      this.requestParam.workType = formData.workType
      this.requestParam.createTimeBegin = formData.createTimeBegin
      this.requestParam.createTimeEnd = formData.createTimeEnd

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    followUpOrderRemark(type){
      console.log(type,'yyyy')
      this.showOrderRemaekDialog = false;
      if(type==false){
        this.flushed()// 需要刷新页面
      }
    },


    // 操作
    handleCommand(command, row) {
      let type = 0;
      let typeName = "";
      let operate = 0;
      if (command === '1') {//启动流程
        if (!this.processDefinitions && this.processDefinitions.length < 1) {
          this.$message.error('未获取到事务单流程');
          return;
        }
        let processDefinitionId = null
        this.processDefinitions.forEach(element => {
          if (element.wfName == "事务单-" + row.workTypeName) {
            processDefinitionId = element.id
            return
          }
        });
        console.log("processDefinitionId", processDefinitionId)
        if (!processDefinitionId) {
          this.$message.error('未找到对应流程');
          return;
        }
        operate = 1;
        this.$mask.open()
        this.$http({
          url: api.act.startWfUrl,
          method: 'post',
          data:{id:row.id,tableKey:"WkWorkBill", orgId: row.orgId, orderNo: row.billNo,siteId:row.siteId,processDefinitionId: processDefinitionId},
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if(response.data.type == "success"){
            this.$message({ message:response.data.content,type: 'success'});
            this.flushed()
          }else{
            this.$message({ message:response.data.content,type: 'warning'});
          }
        })
      }else if(command === '2'){//审核
        operate = 1;
        type = 5;
        this.dataId = row.id;
        this.showOrderRemaekDialog = true;
      }else if(command === '3'){//驳回
        type = 6
        typeName ="驳回"
      }else if(command === '4'){//取消
        type = 99
        typeName ="取消"
      }else if(command === '5'){//重新提交
        type = 2
        typeName ="重新提交"
      }else if(command === '6'){//提交
        type = 2
        typeName ="提交"
      } else if (command === '7') { //查看流程
        operate = 1
        this.actPicUrl = `/act/wf/wfview/` + row.processId
        this.showPicDialog = true
      }
      if(operate === 0){
        this.$baseConfirm('您确定要'+typeName+'吗？').then(() => {
          this.$http({
            url: api.workBill.doOperateUrl,
            method: 'post',
            data:{id:row.id,stat:type},
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            if(response.data.type == "success"){
              this.$message({ message:response.data.content,type: 'success'});
              this.flushed()
            }else{
              this.$message({ message:response.data.content,type: 'warning'});
            }
          })
        })
      }
      this.$mask.close()

    },


    // 详情显示
    showInfo(row, $event) {
      this.openEditDialog(row, 'info')
    },

    // 新增/修改
    openEditDialog(row, type) {
      this.type = type
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.processId=row.processId

      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },




    // 选中的按钮



    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },
    doExcle() {
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.parts).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(api.workBill.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      })
    },



  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

// ::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
//   display: inline-block;
//   width: 20%;
// }

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
